import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faCheck,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import IServicioIndividual from "../../interfaces/IServicioIndividual";

interface Props {
  servicio: IServicioIndividual;
  selected: boolean;
  onToggle: (servicio: IServicioIndividual, checked: boolean) => void;
}

const formatARS = (raw: string | number) => {
  const n = typeof raw === "number" ? raw : Number(String(raw).replace(/[^\d.-]/g, ""));
  if (isNaN(n)) return String(raw);
  return new Intl.NumberFormat("es-AR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

export default function CartCard({ servicio, selected, onToggle }: Props) {
  const handleClick = () => onToggle(servicio, !selected);

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") handleClick();
      }}
      className={`mxd-card ${selected ? "mxd-card--selected" : ""}`}
    >
      <div className="mxd-card-top">
        <span className="mxd-card-tag">{servicio.D_TIPO}</span>
        {selected && (
          <span className="mxd-card-check" aria-label="Sumado">
            <FontAwesomeIcon icon={faCheck} />
          </span>
        )}
      </div>

      <h6 className="mxd-card-title">
        {servicio.D_LISTA_SERVICIOS || servicio.D_TIPO}
      </h6>

      <div className="mxd-card-meta">
        <FontAwesomeIcon icon={faCalendar} className="mxd-card-meta-icon" />
        <span>Vence el {servicio.F_VENCIMIENTO}</span>
      </div>

      <div className="mxd-card-bottom">
        <span className="mxd-card-amount">
          <span className="mxd-card-amount-currency">
            {servicio.MONEDA || "$"}
          </span>
          {formatARS(servicio.IMP_PAGAR ?? servicio.D_IMPORTE)}
        </span>

        <button
          type="button"
          className={`mxd-card-cta ${selected ? "mxd-card-cta--remove" : ""}`}
          onClick={(e) => {
            e.stopPropagation();
            handleClick();
          }}
        >
          <FontAwesomeIcon icon={selected ? faTrash : faPlus} />
          {selected ? "Quitar" : "Sumar"}
        </button>
      </div>
    </div>
  );
}
